import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HighchartsChartModule } from 'highcharts-angular';

@Component({
  selector: 'app-trading-system-grafico-weekly',
  standalone: true,
  templateUrl: './trading-system-grafico-weekly.component.html',
  styleUrls: ['./trading-system-grafico-weekly.component.scss'],
  imports: [HighchartsChartModule]
})
export class TradingSystemGraficoWeeklyComponent implements OnInit {
  @Input() titolo: string = ''
  chartOptions: Highcharts.Options = {}
  Highcharts: typeof Highcharts = Highcharts;
  chartConstructor: string = 'chart';
  updateFlag: boolean = false; // optional boolean
  oneToOneFlag: boolean = true; // optional boolean, defaults to false
  runOutsideAngular: boolean = false; // optional boolean, defaults to false
  runOutsideAngularFlag = false; // optional boolean, defaults to false

  constructor() { }

  ngOnInit(): void {

  }

  caricaDati(serie: any[]) {
    let s1 = serie.reduce((acc, el) => {
      if ((new Date(el.ora)).getDay() == 1) { acc += el.profit }
      return acc
    }, 0)
    let s2 = serie.reduce((acc, el) => {
      if ((new Date(el.ora)).getDay() == 2) { acc += el.profit }
      return acc
    }, 0)
    let s3 = serie.reduce((acc, el) => {
      if ((new Date(el.ora)).getDay() == 3) { acc += el.profit }
      return acc
    }, 0)
    let s4 = serie.reduce((acc, el) => {
      if ((new Date(el.ora)).getDay() == 4) { acc += el.profit }
      return acc
    }, 0)
    let s5 = serie.reduce((acc, el) => {
      if ((new Date(el.ora)).getDay() == 5) { acc += el.profit }
      return acc
    }, 0)

    let ser = [{ name: 'Lunedì', y: s1 }, { name: 'Martedì', y: s2 }, { name: 'Mercoledì', y: s3 }, { name: 'Giovedì', y: s4 }, { name: 'Venerdì', y: s5 }]
    //ser = [s1,s2,s3,s4,s5]
    this.chartOptions = {
      title: {
        text: this.titolo
      },
      chart: {
        type: 'column'
      }, 
      xAxis: {
        type: 'category'
      },
      series: [{
        name: 'Punti',
        data: ser,//[1,2,3,4,5,6,7,8,9,10],
        type: 'column'
      }]
    }
  }

  caricaDatiMese(serie: any[]) {
    let arrMese = []
    let labels = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
    for (let i = 0; i < 12; i++) {
      let s1 = serie.reduce((acc, el) => {
        if ((new Date(el.ora)).getMonth() == i) { acc += el.profit }
        return acc
      }, 0)
      arrMese.push({name: labels[i], y: s1})
    }
    this.chartOptions = {
      title: {
        text: this.titolo
      },
      chart: {
        type: 'column'
      }, 
      xAxis: {
        type: 'category'
      },
      series: [{
        name: 'Punti',
        data: arrMese,
        type: 'column'
      }]
    }
  }

  caricaDatiOrario(serie: any[]) {
    let arrOra = []
    for (let i = 0; i < 24; i++) {
      let s1 = serie.reduce((acc, el) => {
        if ((new Date(el.ora)).getHours() == i) { acc += el.profit }
        return acc
      }, 0)
      arrOra.push({name: i.toString(), y: s1})
    }
    this.chartOptions = {
      title: {
        text: this.titolo
      },
      chart: {
        type: 'column'
      }, 
      xAxis: {
        type: 'category'
      },
      series: [{
        name: 'Punti',
        data: arrOra,
        type: 'column'
      }]
    }
  }

}
